import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { ToggleButtons } from './UI';

function Settings({state, setSettingValue, pass, setPassWrapper, socketError}) {
	const [value, setValue] = useState('');
	const zigbeeDevices = state.devices.filter(x => x.type.includes('Zigbee'));
	const qotDevices = state.devices.filter(x => x.type.includes('Qot'));

	const handleSubmit = (e) => {
		e.preventDefault();
		setPassWrapper(value);
	}

	return (
		<div className='settings'>
			{pass ?
				<div>
					<p>The password has been set.</p>
					<button onClick={() => setPassWrapper('')}>Log out</button>
				</div>
			:
				<div>
					<p>Enter controller password:</p>

					<form onSubmit={handleSubmit}>
						<input
							type='password'
							value={value}
							onChange={(e) => setValue(e.target.value)}
						/>

						<button type='submit'>Set</button>
					</form>
				</div>
			}

			{!!socketError && <p>Socket error: {socketError.message}</p>}

			<p/>

			<ToggleButtons
				value={state.settings.sleep_furnace_fan}
				values={[
					{name: 'Yes', value: true},
					{name: 'No', value: false},
				]}
				setValue={(x) => setSettingValue('sleep_furnace_fan', x)}
				text='Sleep furnace fan'
			/>

			<ToggleButtons
				value={state.settings.sleep_downstairs}
				values={[
					{name: 'Yes', value: true},
					{name: 'No', value: false},
				]}
				setValue={(x) => setSettingValue('sleep_downstairs', x)}
				text='Sleep downstairs'
			/>

			<ToggleButtons
				value={state.settings.defer_priority_alerts}
				values={[
					{name: 'Yes', value: true},
					{name: 'No', value: false},
				]}
				setValue={(x) => setSettingValue('defer_priority_alerts', x)}
				text='Defer alerts'
			/>

			{!!qotDevices.length && qotDevices.map(x =>
				<>
				{x.type.includes('Motion') || x.type.includes('Contact') ?
					<ToggleButtons
						value={''}
						values={[
							{name: 'Press', value: true},
						]}
						setValue={() => setSettingValue('test_motion', x.serial)}
						text=''
						other={x.name}
					/>
				:
					<p style={{fontSize: '1.75rem'}}>{x.name}</p>
				}
				<p>Last seen: {x.last_seen ? moment(x.last_seen * 1000).fromNow() : 'Never'}</p>
				</>
			)}

			{!!zigbeeDevices.length && zigbeeDevices.map(x =>
				<>
				{x.type.includes('Motion') || x.type.includes('Contact') ?
					<ToggleButtons
						value={''}
						values={[
							{name: 'Press', value: true},
						]}
						setValue={() => setSettingValue('test_motion', x.serial)}
						text=''
						other={x.name}
					/>
				:
					<p style={{fontSize: '1.75rem'}}>{x.name}</p>
				}
				<p>Last seen: {x.last_seen ? moment(x.last_seen * 1000).fromNow() : 'Never'}</p>
				</>
			)}

			<ToggleButtons
				value={''}
				values={[
					{name: 'Press', value: true},
				]}
				setValue={() => setSettingValue('reset_garage_door', true)}
				text=''
				other={'Reset garage door'}
			/>

			<ToggleButtons
				value={''}
				values={[
					{name: 'Press', value: true},
				]}
				setValue={() => setSettingValue('test_priority_alert', true)}
				text=''
				other={'Test alert'}
			/>

			<ToggleButtons
				value={''}
				values={[
					{name: 'Press', value: true},
				]}
				setValue={() => setSettingValue('kill', true)}
				text=''
				other={'Kill server'}
			/>

			<ToggleButtons
				value={''}
				values={[
					{name: 'Press', value: true},
				]}
				setValue={() => setSettingValue('test_bark', true)}
				text=''
				other={'Test Bark'}
			/>

			<ToggleButtons
				value={''}
				values={[
					{name: 'Press', value: true},
				]}
				setValue={() => setSettingValue('real_bark', true)}
				text=''
				other={'Real Bark'}
			/>

			<ToggleButtons
				value={''}
				values={[
					{name: 'Press', value: true},
				]}
				setValue={() => setSettingValue('stop_bark', true)}
				text=''
				other={'Stop Bark'}
			/>
		</div>
	);
}

export default Settings;
